import { Dispatch, ReactNode, SetStateAction, createContext, useEffect, useState } from 'react';

type UserDataContextType = {
  userName: string;
  userEmail: string;
  admin: boolean;
  token: string;
}

type UserDataContextProps = {
  userData: UserDataContextType
  setUserData: Dispatch<SetStateAction<UserDataContextType>>;
}

type UserDataProviderProps = {
  children: ReactNode
}

function getInfoUser() {
  const infoUserData = localStorage.getItem('user');

  if (infoUserData) {
    const parsedInfo = JSON.parse(infoUserData);
    const { token, infoUser } = parsedInfo;

    return { infoUser, token };
  }
}

const dataUser = getInfoUser();

const DEFAULT_VALUE: UserDataContextProps = {
  userData: {
    userName: dataUser && dataUser.infoUser.name || '',
    userEmail: dataUser && dataUser.infoUser.email || '',
    admin: dataUser && dataUser.infoUser.adm || false,
    token: dataUser && dataUser.token || ''
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setUserData: () => { }
};

export const UserDataContext = createContext<UserDataContextProps>(DEFAULT_VALUE);

export function UserDataProvider({ children }: UserDataProviderProps) {
  const [userData, setUserData] = useState(DEFAULT_VALUE.userData);

  useEffect(() => {
    getInfoUser();
  }, []);

  return (
    <UserDataContext.Provider
      value={{
        userData,
        setUserData
      }}
    >
      {children}
    </UserDataContext.Provider>
  );
}
